import Model from './BaseClasses/Model';
export default class Task extends Model {
    constructor(ref, key = false){
        super(ref, key);
        this.fillable = {
            event:false,
            description: false,
            data: false,
            timestamp: new Date().getTime()
        }
    }
}